import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BusyTimeListResponse, SearchBusyTimeRequest } from '../models';

interface BusyTimeState {
  busyTimeList: BusyTimeListResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: BusyTimeState = {
  busyTimeList: null,
  loading: false,
  error: null,
};

const busyTimeSlice = createSlice({
  name: 'busyTime',
  initialState,
  reducers: {
    fetchBusyTimeListStart: (state, action: PayloadAction<SearchBusyTimeRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchBusyTimeListSuccess: (state, action: PayloadAction<BusyTimeListResponse>) => {
      state.loading = false;
      state.busyTimeList = action.payload;
      state.error = null;
    },
    fetchBusyTimeListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearBusyTimeList: (state) => {
      state.busyTimeList = null;
      state.error = null;
    },
  },
});

export const busyTimeActions = busyTimeSlice.actions;
export const busyTimeReducer = busyTimeSlice.reducer;

// Selectors
export const selectBusyTimeList = (state: any) => state.busyTime.busyTimeList;
export const selectLoadingBusyTime = (state: any) => state.busyTime.loading;
export const selectBusyTimeError = (state: any) => state.busyTime.error;

